import { useState, useEffect } from "react";

let toastFn = null;

export function showToast(msg) {
  if (toastFn) toastFn(msg);
}

export default function Toast() {
  const [msg, setMsg]     = useState("");
  const [show, setShow]   = useState(false);
  let timer;

  useEffect(() => {
    toastFn = (m) => {
      setMsg(m);
      setShow(true);
      clearTimeout(timer);
      timer = setTimeout(() => setShow(false), 3000);
    };
    return () => { toastFn = null; };
  }, []);

  return (
    <div style={{
      position: "fixed", bottom: "1.5rem", left: "50%",
      transform: show ? "translateX(-50%) translateY(0)" : "translateX(-50%) translateY(20px)",
      background: "var(--text)", color: "var(--bg)",
      padding: ".7rem 1.4rem", borderRadius: "99px",
      fontSize: ".875rem", fontWeight: 500,
      zIndex: 500, opacity: show ? 1 : 0, pointerEvents: "none",
      transition: "all .3s", whiteSpace: "nowrap",
    }}>
      {msg}
    </div>
  );
}